module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10224.2e080264.jpg";